export default __webpack_public_path__ + "static/media/logoSimple.370924ef.png";